<template>
    <select>
        <option v-for="option in options" :value="option.id">{{ option.label }}</option>
    </select>
</template>

<script>
    export default {
        props: ['options', 'value', 'placeholder'],

        watch: {
            value(val) {
                this.$nextTick(function () {
                    $(this.$el).val(val);
                    this.$el.sumo.reload();
                });
            },
            options() {
                this.$nextTick(function () {
                    this.$el.sumo.reload();
                });
            }
        },

        mounted() {
            var vm = this;
            $(this.$el)
                .val(this.value)
                .SumoSelect({
                    placeholder: this.placeholder
                });
            $(this.$el)
                .on('change', function () {
                    vm.$emit('input', $(vm.$el).val())
                });
        }
    }
</script>
